const goodsTypeList = [
    {
        value: 1,
        label: '培训商品'
    },
    {
        value: 2,
        label: '培训分销商品'
    },
    {
        value: 3,
        label: '实物商品',
    },
    {
        value: 5,
        label: '组合商品',
    },
]

const orderGoodsTypeList = [
    {
        value: 1,
        label: '培训订单'
    },
    {
        value: 3,
        label: '商品订单'
    },
    // {
    //     value: 5,
    //     label: '组合订单'
    // },
    // {
    //     value: 6,
    //     label: '会员订单'
    // },
]
// 培训订单状态

const orderStatusList = [
    {
        value: '',
        label: '全部订单'
    },
    {
        value: 0,
        label: '待付款'
    },
    {
        value: 2,
        label: '已完成'
    },
    {
        value: 9,
        label: '已关闭'
    },
    
]

// 商品订单状态
const entityOrderStatusList = [
    {
        value: '',
        label: '全部订单'
    },
    {
        value: 0,
        label: '待付款'
    },
    {
        value: 3,
        label: '待发货'
    },
    {
        value: 4,
        label: '已发货'
    },
    // 确认收货
    {
        value: 5,
        label: '已完成'
    },
    {
        value: 9,
        label: '已关闭'
    },
    {
        value: 10,
        label: '退款/售后'
    },
]
// 组合订单状态
const compositeOrderStatusList = [
    {
        value: '',
        label: '全部订单'
    },
    {
        value: 0,
        label: '待付款'
    },
    {
        value: 3,
        label: '待发货'
    },
    {
        value: 4,
        label: '已发货'
    },
    // 确认收货
    {
        value: 5,
        label: '已完成'
    },
    {
        value: 9,
        label: '已关闭'
    },
    {
        value: 10,
        label: '退款/售后'
    },
]
// 会员订单状态
const memberOrderStatusList = [
    {
        value: '',
        label: '全部订单'
    },
    {
        value: 0,
        label: '待付款'
    },
    {
        value: 3,
        label: '已完成'
    },
    {
        value: 4,
        label: '已关闭'
    },
]
const payStatusList = [
    {
        value: 0,
        label: '待支付'
    },
    {
        value: 2,
        label: '已完成'
    },
    {
        value: 8,
        label: '已关闭'
    },
    {
        value: 9,
        label: '已关闭'
    },
]
const studyStatus = [
    {
        value: 1,
        label: '未开始'
    },
    {
        value: 2,
        label: '进行中'
    },
    {
        value: 3,
        label: '已结束'
    },
]

const taskContentType = {
    1:{
        text:'目录',
        icon:''
    },
    2:{
        text:'课程',
        icon:''
    },
    3:{
        text:'考试',
        icon:''
    },
    4:{
        text:'直播',
        icon:''
    },
    5:{
        text:'线上实训',
        icon:''
    },
    6:{
        text:'表单',
        icon:''
    },
    7:{
        text:'练习',
        icon:''
    },
    8:{
        text:'线下实训',
        icon:''
    },

};
const orderStatusText = {
    //订单状态
    0:{
        label: '待支付',
        icon: '2',
        value: 0,
    },
    
    8:{
        label: '已关闭',
        tips: '订单已取消',
        icon: '3',
        value: 8
    },
    9:{
        label: '已关闭',
        tips: '订单超时',
        icon: '3',
        value: 9
    },
}

const deliveryStatusText = {
    // 物流状态
    3:{
        value: 3,
        label: '待发货',
        tips: '买家已付款',
        icon: '2',
    },
    4:{
        value: 4,
        label: '商家已发货',
        icon: '1',
    },
    5:{
        label: '交易完成',
        tips: '交易成功',
        icon: '4',
        value: 5,
    },
}




export {
    goodsTypeList,
    orderGoodsTypeList,
    orderStatusList,
    entityOrderStatusList,
    payStatusList,
    studyStatus,
    taskContentType,
    compositeOrderStatusList,
    memberOrderStatusList,
    orderStatusText,
    deliveryStatusText
}